// prettier-ignore
export default {
    "email": "@",
    "pk": "id",
    "is_staff": "is",
    "name": "fn",
    "cart_counter": "k",
    "signup_time": "sg",
    "has_discount": "d"
}